import qs from 'qs'

export const useZhichiService = () => {
  const openZhichiService = () => {
      var ua = navigator.userAgent.toLowerCase()
      var isMobileRegex = /android|webos|iphone|blackberry|iemobile|opera mini/i
      var isMobile = isMobileRegex.test(ua)
      const defaultParams = {
        sysnum: "78a42d531fd54320b3e99bda9fa36735",
        channelid: 26,
        faqid: 19
      }
      const mainUrl = isMobile
      ? "https://okki.sobot.com/chat/h5/v2/index.html"
      : "https://okki.sobot.com/chat/pc/v2/index.html"

      window.open(`${mainUrl}?${qs.stringify(defaultParams)}`)
      return
    }
  
  return {
    openZhichiService,
  }
}
